<template>
    <div class="bg-white p-6 shadow-md rounded-lg">
        <h2 class="text-lg font-semibold text-gray-700 mb-4 flex items-center">
            <font-awesome-icon :icon="['fas', 'clipboard-list']" class="text-blue-600 mr-2" />
            Application Status Distribution
        </h2>
        <div v-if="hasData">
            <apexchart type="donut" height="350" :options="chartOptions" :series="chartSeries" />
        </div>
        <div v-else class="text-gray-500 text-center py-16">
            <div class="text-4xl mb-2">📊</div>
            <div>There is no data to show</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ApplicationStatusChart",
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        hasData() {
            return this.data && this.data.length > 0;
        },
        chartSeries() {
            return this.data.map(item => item.count);
        },
        chartOptions() {
            const labels = this.data.map(item => item.application_status);
            const colors = this.getStatusColors(labels);

            return {
                labels: labels,
                colors: colors,
                legend: {
                    position: 'bottom',
                    formatter: (seriesName, opts) => {
                        const seriesIndex = opts.seriesIndex;
                        const value = this.chartSeries[seriesIndex];
                        return `${seriesName} - ${value}`;
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val.toFixed(1) + '%';
                    },
                },
                tooltip: {
                    y: {
                        formatter: (val) => `${val} Applications`,
                    },
                },
                chart: {
                    type: 'donut',
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '70%',
                            labels: {
                                show: true,
                                total: {
                                    show: true,
                                    label: 'Total',
                                    formatter: () => this.getTotalApplications()
                                }
                            }
                        }
                    }
                }
            };
        }
    },
    methods: {
        getStatusColors(labels) {
            const colorMap = {
                'MD Approved': '#70AD47',
                'Admission committee Rejected': '#E74C3C',
                'Interview Committee Approved': '#3498DB',
                'Admission committee Returned': '#F39C12',
                'New Application': '#9B59B6',
                'Pending': '#95A5A6'
            };

            return labels.map(label => colorMap[label] || '#95A5A6');
        },
        getTotalApplications() {
            return this.data.reduce((total, item) => total + item.count, 0);
        }
    }
};
</script>
